import * as boHelper              from '../batchOperationDialogActionsHelper';
import * as lotsService from '../../../services/Lots/lotsService';
import {dialogsNames} from '../../../enums/dialogsNames';
/////////////////////////////////////////
// ACTION TYPES - PUBLIC, FOR REDUCERS
export const actionTypes = {
  ...boHelper.getActionTypes(dialogsNames.EDIT_STATUS_DIALOG),
};

////////////////////////////////////////////////////////////////
// PLAIN ACTION CREATORS - PRIVATE, FOR LOCAL DISPATCH ONLY
const actions = {
  ...boHelper.getActions(dialogsNames.EDIT_STATUS_DIALOG),
};

/////////////////////////////////////////////////////////////////////////
// API METHODS - PUBLIC, FOR OTHER ACTION MODULES (and internal use)
const config = {
  submitMethod: lotsService.editLotsStatuses,
  dialogReduxStorageName: 'editStatusDialog'
};

export let api = {
  ...boHelper.getApiActions(actions, config),
};

/////////////////////////////////////////////////////////////////////
// METHODS FOR JSX PROPS - PUBLIC, ALL THUNK TYPE
export let jsxActions = {
  ...boHelper.getJsxActions(api)
};


